import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModal } from '../modal.interface';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
})
export default class ModalComponent {

  // Objeto que contiene los datos del modal
  @Input() modalData!: IModal;

  constructor(
      public activeModal: NgbActiveModal
  ) {}
}
